/**
 *
 * @param {String} text
 * @param {Number} length
 * @param {String} clamp
 *
 */
function truncate() {
  let text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;
  let clamp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '...';
  if (text.length <= length) return text;
  var tcText = text.slice(0, length - clamp.length);
  var last = tcText.length - 1;
  while (last > 0 && tcText[last] !== ' ' && tcText[last] !== clamp[0]) last -= 1;

  // Fix for case when text dont have any `space`
  last = last || length - clamp.length;
  tcText = tcText.slice(0, last);
  return tcText + clamp;
}
export { truncate };